import { defineComponent as c, computed as l, openBlock as i, createElementBlock as h, createElementVNode as e, toDisplayString as r, createCommentVNode as p, normalizeStyle as f, createStaticVNode as n } from "vue";
const m = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "f9277d93-3c4f-49c6-85d6-20938327101b" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#f9277d93-3c4f-49c6-85d6-20938327101b)" }, k = { key: 0 }, u = /* @__PURE__ */ n('<path fill="#d80027" d="M256 0h256v512H0V256z"></path><path fill="#eee" d="M0 0h33.4l31.8 16.4 35-16.4H256v133.6l-9.3 33.7 9.3 41.5V256h-47.2l-39.3-7-35.9 7.1L0 256V100.2l15.4-34.5L0 33.4z"></path><path fill="#496e2d" d="M445.2 256.1zm-155.8 0z"></path><path fill="#d80027" d="m267 235.5-102-102h-31.4L267 267z"></path><path fill="#d80027" d="M33.4 0v33.4H0v66.8h33.4v170.6h66.8V100.2h170.2V33.4H100.2V0z"></path><path fill="#0052b4" d="M180.8 133.6H256v75.2zm-47.2 47.2v75.3l75.2-.1z"></path><path fill="#eee" d="M289.4 133.6V256c0 59.6 155.8 59.6 155.8 0V133.6z"></path><path fill="#6da544" d="M289.4 256c0 59.6 77.9 78 77.9 78s78-18.4 78-78h-156z"></path><path fill="#a2001d" d="m367.3 207-36.2 15.6V256l36.2 22.3 36.2-22.3v-33.4z"></path><path fill="#338af3" d="M331.1 189.2h72.4v33.4H331z"></path>', 10), z = { fill: "none" }, g = ["r"], w = /* @__PURE__ */ c({
  __name: "bm",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const t = s, o = l(() => 512 + 2 * t.strokeWidth), a = l(() => -t.strokeWidth), d = l(() => 256 + t.strokeWidth / 2);
    return (V, x) => (i(), h("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      v,
      e("g", _, [
        t.flagName ? (i(), h("title", k, r(t.flagName), 1)) : p("", !0),
        u
      ]),
      e("g", z, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, g)
      ])
    ], 8, m));
  }
});
export {
  w as default
};
//# sourceMappingURL=bm-e6474f6f.js.map
